declare const utag: any;

export const trackEvent = (
  category: string,
  action: string,
  label?: string
) => {
  if ("utag" in window) {
    utag.link({
      page_url: location.href,
      event_category: category,
      event_action: action,
      event_label: label
    });
  }
};
